import React from "react";
import { DeleteConfirmationPopupProps } from "./delete-confirmation-props";
import trashIcon from "../../../assets/icons/trashIcon.svg";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import "./delete-confirmation-popup.scss";

const RemoveUserConfirmationPopup: React.FC<DeleteConfirmationPopupProps> = ({
  isOpen,
  onClose,
  handleDelete,
  deleteId,
  label,
}) => {
  if (!isOpen) return null;
  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));
  return (
    <BootstrapDialog aria-labelledby="customized-dialog-title" open={true}>
      <div className="delete-popup">
        <div className="delete-popup-image-box">
          <div className="delete-popup-image">
            <div className="trashIcon-background">
              <img src={trashIcon} alt="trash-icon" />
            </div>
          </div>
        </div>
        <h4 className="delete-title">Remove User</h4>
        <p className="delete-message">
          Would you like to remove user from {label}?
        </p>
        <div className="delete-buttons">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button
            className="delete-button"
            onClick={() => handleDelete(deleteId)}
          >
            Remove
          </button>
        </div>
      </div>
    </BootstrapDialog>
  );
};

export default RemoveUserConfirmationPopup;
